/**
 * @fileoverview gRPC-Web generated client stub for mw.customer
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v5.28.2
// source: customer/customer.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var common_common_pb = require('../common/common_pb.js')
const proto = {};
proto.mw = {};
proto.mw.customer = require('./customer_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.mw.customer.CustomerServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.mw.customer.CustomerServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mw.customer.AuthenticateRequest,
 *   !proto.mw.customer.AuthenticateResponse>}
 */
const methodDescriptor_CustomerService_Authenticate = new grpc.web.MethodDescriptor(
  '/mw.customer.CustomerService/Authenticate',
  grpc.web.MethodType.UNARY,
  proto.mw.customer.AuthenticateRequest,
  proto.mw.customer.AuthenticateResponse,
  /**
   * @param {!proto.mw.customer.AuthenticateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mw.customer.AuthenticateResponse.deserializeBinary
);


/**
 * @param {!proto.mw.customer.AuthenticateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mw.customer.AuthenticateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mw.customer.AuthenticateResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mw.customer.CustomerServiceClient.prototype.authenticate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mw.customer.CustomerService/Authenticate',
      request,
      metadata || {},
      methodDescriptor_CustomerService_Authenticate,
      callback);
};


/**
 * @param {!proto.mw.customer.AuthenticateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mw.customer.AuthenticateResponse>}
 *     Promise that resolves to the response
 */
proto.mw.customer.CustomerServicePromiseClient.prototype.authenticate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mw.customer.CustomerService/Authenticate',
      request,
      metadata || {},
      methodDescriptor_CustomerService_Authenticate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mw.customer.RequestNewPasswordTokenRequest,
 *   !proto.mw.customer.RequestNewPasswordTokenResponse>}
 */
const methodDescriptor_CustomerService_RequestNewPasswordToken = new grpc.web.MethodDescriptor(
  '/mw.customer.CustomerService/RequestNewPasswordToken',
  grpc.web.MethodType.UNARY,
  proto.mw.customer.RequestNewPasswordTokenRequest,
  proto.mw.customer.RequestNewPasswordTokenResponse,
  /**
   * @param {!proto.mw.customer.RequestNewPasswordTokenRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mw.customer.RequestNewPasswordTokenResponse.deserializeBinary
);


/**
 * @param {!proto.mw.customer.RequestNewPasswordTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mw.customer.RequestNewPasswordTokenResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mw.customer.RequestNewPasswordTokenResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mw.customer.CustomerServiceClient.prototype.requestNewPasswordToken =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mw.customer.CustomerService/RequestNewPasswordToken',
      request,
      metadata || {},
      methodDescriptor_CustomerService_RequestNewPasswordToken,
      callback);
};


/**
 * @param {!proto.mw.customer.RequestNewPasswordTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mw.customer.RequestNewPasswordTokenResponse>}
 *     Promise that resolves to the response
 */
proto.mw.customer.CustomerServicePromiseClient.prototype.requestNewPasswordToken =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mw.customer.CustomerService/RequestNewPasswordToken',
      request,
      metadata || {},
      methodDescriptor_CustomerService_RequestNewPasswordToken);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mw.customer.SaveNewPasswordRequest,
 *   !proto.mw.customer.SaveNewPasswordResponse>}
 */
const methodDescriptor_CustomerService_SaveNewPassword = new grpc.web.MethodDescriptor(
  '/mw.customer.CustomerService/SaveNewPassword',
  grpc.web.MethodType.UNARY,
  proto.mw.customer.SaveNewPasswordRequest,
  proto.mw.customer.SaveNewPasswordResponse,
  /**
   * @param {!proto.mw.customer.SaveNewPasswordRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mw.customer.SaveNewPasswordResponse.deserializeBinary
);


/**
 * @param {!proto.mw.customer.SaveNewPasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mw.customer.SaveNewPasswordResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mw.customer.SaveNewPasswordResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mw.customer.CustomerServiceClient.prototype.saveNewPassword =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mw.customer.CustomerService/SaveNewPassword',
      request,
      metadata || {},
      methodDescriptor_CustomerService_SaveNewPassword,
      callback);
};


/**
 * @param {!proto.mw.customer.SaveNewPasswordRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mw.customer.SaveNewPasswordResponse>}
 *     Promise that resolves to the response
 */
proto.mw.customer.CustomerServicePromiseClient.prototype.saveNewPassword =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mw.customer.CustomerService/SaveNewPassword',
      request,
      metadata || {},
      methodDescriptor_CustomerService_SaveNewPassword);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mw.customer.GetOrdersRequest,
 *   !proto.mw.customer.GetOrdersResponse>}
 */
const methodDescriptor_CustomerService_GetOrders = new grpc.web.MethodDescriptor(
  '/mw.customer.CustomerService/GetOrders',
  grpc.web.MethodType.UNARY,
  proto.mw.customer.GetOrdersRequest,
  proto.mw.customer.GetOrdersResponse,
  /**
   * @param {!proto.mw.customer.GetOrdersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mw.customer.GetOrdersResponse.deserializeBinary
);


/**
 * @param {!proto.mw.customer.GetOrdersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mw.customer.GetOrdersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mw.customer.GetOrdersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mw.customer.CustomerServiceClient.prototype.getOrders =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mw.customer.CustomerService/GetOrders',
      request,
      metadata || {},
      methodDescriptor_CustomerService_GetOrders,
      callback);
};


/**
 * @param {!proto.mw.customer.GetOrdersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mw.customer.GetOrdersResponse>}
 *     Promise that resolves to the response
 */
proto.mw.customer.CustomerServicePromiseClient.prototype.getOrders =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mw.customer.CustomerService/GetOrders',
      request,
      metadata || {},
      methodDescriptor_CustomerService_GetOrders);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mw.customer.CreateOrderRequest,
 *   !proto.mw.customer.CreateOrderResponse>}
 */
const methodDescriptor_CustomerService_CreateOrder = new grpc.web.MethodDescriptor(
  '/mw.customer.CustomerService/CreateOrder',
  grpc.web.MethodType.UNARY,
  proto.mw.customer.CreateOrderRequest,
  proto.mw.customer.CreateOrderResponse,
  /**
   * @param {!proto.mw.customer.CreateOrderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mw.customer.CreateOrderResponse.deserializeBinary
);


/**
 * @param {!proto.mw.customer.CreateOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mw.customer.CreateOrderResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mw.customer.CreateOrderResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mw.customer.CustomerServiceClient.prototype.createOrder =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mw.customer.CustomerService/CreateOrder',
      request,
      metadata || {},
      methodDescriptor_CustomerService_CreateOrder,
      callback);
};


/**
 * @param {!proto.mw.customer.CreateOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mw.customer.CreateOrderResponse>}
 *     Promise that resolves to the response
 */
proto.mw.customer.CustomerServicePromiseClient.prototype.createOrder =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mw.customer.CustomerService/CreateOrder',
      request,
      metadata || {},
      methodDescriptor_CustomerService_CreateOrder);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mw.customer.GetOrderSummaryRequest,
 *   !proto.mw.customer.GetOrderSummaryResponse>}
 */
const methodDescriptor_CustomerService_GetOrderSummary = new grpc.web.MethodDescriptor(
  '/mw.customer.CustomerService/GetOrderSummary',
  grpc.web.MethodType.UNARY,
  proto.mw.customer.GetOrderSummaryRequest,
  proto.mw.customer.GetOrderSummaryResponse,
  /**
   * @param {!proto.mw.customer.GetOrderSummaryRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mw.customer.GetOrderSummaryResponse.deserializeBinary
);


/**
 * @param {!proto.mw.customer.GetOrderSummaryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mw.customer.GetOrderSummaryResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mw.customer.GetOrderSummaryResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mw.customer.CustomerServiceClient.prototype.getOrderSummary =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mw.customer.CustomerService/GetOrderSummary',
      request,
      metadata || {},
      methodDescriptor_CustomerService_GetOrderSummary,
      callback);
};


/**
 * @param {!proto.mw.customer.GetOrderSummaryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mw.customer.GetOrderSummaryResponse>}
 *     Promise that resolves to the response
 */
proto.mw.customer.CustomerServicePromiseClient.prototype.getOrderSummary =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mw.customer.CustomerService/GetOrderSummary',
      request,
      metadata || {},
      methodDescriptor_CustomerService_GetOrderSummary);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mw.customer.ClearProductQuantitiesRequest,
 *   !proto.mw.customer.ClearProductQuantitiesResponse>}
 */
const methodDescriptor_CustomerService_ClearProductQuantities = new grpc.web.MethodDescriptor(
  '/mw.customer.CustomerService/ClearProductQuantities',
  grpc.web.MethodType.UNARY,
  proto.mw.customer.ClearProductQuantitiesRequest,
  proto.mw.customer.ClearProductQuantitiesResponse,
  /**
   * @param {!proto.mw.customer.ClearProductQuantitiesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mw.customer.ClearProductQuantitiesResponse.deserializeBinary
);


/**
 * @param {!proto.mw.customer.ClearProductQuantitiesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mw.customer.ClearProductQuantitiesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mw.customer.ClearProductQuantitiesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mw.customer.CustomerServiceClient.prototype.clearProductQuantities =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mw.customer.CustomerService/ClearProductQuantities',
      request,
      metadata || {},
      methodDescriptor_CustomerService_ClearProductQuantities,
      callback);
};


/**
 * @param {!proto.mw.customer.ClearProductQuantitiesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mw.customer.ClearProductQuantitiesResponse>}
 *     Promise that resolves to the response
 */
proto.mw.customer.CustomerServicePromiseClient.prototype.clearProductQuantities =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mw.customer.CustomerService/ClearProductQuantities',
      request,
      metadata || {},
      methodDescriptor_CustomerService_ClearProductQuantities);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mw.customer.DownloadInvoicePDFRequest,
 *   !proto.mw.customer.DownloadInvoicePDFResponse>}
 */
const methodDescriptor_CustomerService_DownloadInvoicePDF = new grpc.web.MethodDescriptor(
  '/mw.customer.CustomerService/DownloadInvoicePDF',
  grpc.web.MethodType.UNARY,
  proto.mw.customer.DownloadInvoicePDFRequest,
  proto.mw.customer.DownloadInvoicePDFResponse,
  /**
   * @param {!proto.mw.customer.DownloadInvoicePDFRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mw.customer.DownloadInvoicePDFResponse.deserializeBinary
);


/**
 * @param {!proto.mw.customer.DownloadInvoicePDFRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mw.customer.DownloadInvoicePDFResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mw.customer.DownloadInvoicePDFResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mw.customer.CustomerServiceClient.prototype.downloadInvoicePDF =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mw.customer.CustomerService/DownloadInvoicePDF',
      request,
      metadata || {},
      methodDescriptor_CustomerService_DownloadInvoicePDF,
      callback);
};


/**
 * @param {!proto.mw.customer.DownloadInvoicePDFRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mw.customer.DownloadInvoicePDFResponse>}
 *     Promise that resolves to the response
 */
proto.mw.customer.CustomerServicePromiseClient.prototype.downloadInvoicePDF =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mw.customer.CustomerService/DownloadInvoicePDF',
      request,
      metadata || {},
      methodDescriptor_CustomerService_DownloadInvoicePDF);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mw.customer.GetOrderFormV2Request,
 *   !proto.mw.customer.GetOrderFormV2Response>}
 */
const methodDescriptor_CustomerService_GetOrderFormV2 = new grpc.web.MethodDescriptor(
  '/mw.customer.CustomerService/GetOrderFormV2',
  grpc.web.MethodType.UNARY,
  proto.mw.customer.GetOrderFormV2Request,
  proto.mw.customer.GetOrderFormV2Response,
  /**
   * @param {!proto.mw.customer.GetOrderFormV2Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mw.customer.GetOrderFormV2Response.deserializeBinary
);


/**
 * @param {!proto.mw.customer.GetOrderFormV2Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mw.customer.GetOrderFormV2Response)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mw.customer.GetOrderFormV2Response>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mw.customer.CustomerServiceClient.prototype.getOrderFormV2 =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mw.customer.CustomerService/GetOrderFormV2',
      request,
      metadata || {},
      methodDescriptor_CustomerService_GetOrderFormV2,
      callback);
};


/**
 * @param {!proto.mw.customer.GetOrderFormV2Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mw.customer.GetOrderFormV2Response>}
 *     Promise that resolves to the response
 */
proto.mw.customer.CustomerServicePromiseClient.prototype.getOrderFormV2 =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mw.customer.CustomerService/GetOrderFormV2',
      request,
      metadata || {},
      methodDescriptor_CustomerService_GetOrderFormV2);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mw.customer.GetOrderFormV2GroupedRequest,
 *   !proto.mw.customer.GetOrderFormV2GroupedResponse>}
 */
const methodDescriptor_CustomerService_GetOrderFormV2Grouped = new grpc.web.MethodDescriptor(
  '/mw.customer.CustomerService/GetOrderFormV2Grouped',
  grpc.web.MethodType.UNARY,
  proto.mw.customer.GetOrderFormV2GroupedRequest,
  proto.mw.customer.GetOrderFormV2GroupedResponse,
  /**
   * @param {!proto.mw.customer.GetOrderFormV2GroupedRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mw.customer.GetOrderFormV2GroupedResponse.deserializeBinary
);


/**
 * @param {!proto.mw.customer.GetOrderFormV2GroupedRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mw.customer.GetOrderFormV2GroupedResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mw.customer.GetOrderFormV2GroupedResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mw.customer.CustomerServiceClient.prototype.getOrderFormV2Grouped =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mw.customer.CustomerService/GetOrderFormV2Grouped',
      request,
      metadata || {},
      methodDescriptor_CustomerService_GetOrderFormV2Grouped,
      callback);
};


/**
 * @param {!proto.mw.customer.GetOrderFormV2GroupedRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mw.customer.GetOrderFormV2GroupedResponse>}
 *     Promise that resolves to the response
 */
proto.mw.customer.CustomerServicePromiseClient.prototype.getOrderFormV2Grouped =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mw.customer.CustomerService/GetOrderFormV2Grouped',
      request,
      metadata || {},
      methodDescriptor_CustomerService_GetOrderFormV2Grouped);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mw.customer.SubmitContactFormRequest,
 *   !proto.mw.customer.SubmitContactFormResponse>}
 */
const methodDescriptor_CustomerService_SubmitContactForm = new grpc.web.MethodDescriptor(
  '/mw.customer.CustomerService/SubmitContactForm',
  grpc.web.MethodType.UNARY,
  proto.mw.customer.SubmitContactFormRequest,
  proto.mw.customer.SubmitContactFormResponse,
  /**
   * @param {!proto.mw.customer.SubmitContactFormRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mw.customer.SubmitContactFormResponse.deserializeBinary
);


/**
 * @param {!proto.mw.customer.SubmitContactFormRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mw.customer.SubmitContactFormResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mw.customer.SubmitContactFormResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mw.customer.CustomerServiceClient.prototype.submitContactForm =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mw.customer.CustomerService/SubmitContactForm',
      request,
      metadata || {},
      methodDescriptor_CustomerService_SubmitContactForm,
      callback);
};


/**
 * @param {!proto.mw.customer.SubmitContactFormRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mw.customer.SubmitContactFormResponse>}
 *     Promise that resolves to the response
 */
proto.mw.customer.CustomerServicePromiseClient.prototype.submitContactForm =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mw.customer.CustomerService/SubmitContactForm',
      request,
      metadata || {},
      methodDescriptor_CustomerService_SubmitContactForm);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mw.customer.GetMiniShopRequest,
 *   !proto.mw.customer.GetMiniShopResponse>}
 */
const methodDescriptor_CustomerService_GetMiniShop = new grpc.web.MethodDescriptor(
  '/mw.customer.CustomerService/GetMiniShop',
  grpc.web.MethodType.UNARY,
  proto.mw.customer.GetMiniShopRequest,
  proto.mw.customer.GetMiniShopResponse,
  /**
   * @param {!proto.mw.customer.GetMiniShopRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mw.customer.GetMiniShopResponse.deserializeBinary
);


/**
 * @param {!proto.mw.customer.GetMiniShopRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mw.customer.GetMiniShopResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mw.customer.GetMiniShopResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mw.customer.CustomerServiceClient.prototype.getMiniShop =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mw.customer.CustomerService/GetMiniShop',
      request,
      metadata || {},
      methodDescriptor_CustomerService_GetMiniShop,
      callback);
};


/**
 * @param {!proto.mw.customer.GetMiniShopRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mw.customer.GetMiniShopResponse>}
 *     Promise that resolves to the response
 */
proto.mw.customer.CustomerServicePromiseClient.prototype.getMiniShop =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mw.customer.CustomerService/GetMiniShop',
      request,
      metadata || {},
      methodDescriptor_CustomerService_GetMiniShop);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mw.customer.ValidateMiniShopOrderRequest,
 *   !proto.mw.customer.ValidateMiniShopOrderResponse>}
 */
const methodDescriptor_CustomerService_ValidateMiniShopOrder = new grpc.web.MethodDescriptor(
  '/mw.customer.CustomerService/ValidateMiniShopOrder',
  grpc.web.MethodType.UNARY,
  proto.mw.customer.ValidateMiniShopOrderRequest,
  proto.mw.customer.ValidateMiniShopOrderResponse,
  /**
   * @param {!proto.mw.customer.ValidateMiniShopOrderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mw.customer.ValidateMiniShopOrderResponse.deserializeBinary
);


/**
 * @param {!proto.mw.customer.ValidateMiniShopOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mw.customer.ValidateMiniShopOrderResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mw.customer.ValidateMiniShopOrderResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mw.customer.CustomerServiceClient.prototype.validateMiniShopOrder =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mw.customer.CustomerService/ValidateMiniShopOrder',
      request,
      metadata || {},
      methodDescriptor_CustomerService_ValidateMiniShopOrder,
      callback);
};


/**
 * @param {!proto.mw.customer.ValidateMiniShopOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mw.customer.ValidateMiniShopOrderResponse>}
 *     Promise that resolves to the response
 */
proto.mw.customer.CustomerServicePromiseClient.prototype.validateMiniShopOrder =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mw.customer.CustomerService/ValidateMiniShopOrder',
      request,
      metadata || {},
      methodDescriptor_CustomerService_ValidateMiniShopOrder);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mw.customer.CreateMiniShopOrderRequest,
 *   !proto.mw.customer.CreateMiniShopOrderResponse>}
 */
const methodDescriptor_CustomerService_CreateMiniShopOrder = new grpc.web.MethodDescriptor(
  '/mw.customer.CustomerService/CreateMiniShopOrder',
  grpc.web.MethodType.UNARY,
  proto.mw.customer.CreateMiniShopOrderRequest,
  proto.mw.customer.CreateMiniShopOrderResponse,
  /**
   * @param {!proto.mw.customer.CreateMiniShopOrderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mw.customer.CreateMiniShopOrderResponse.deserializeBinary
);


/**
 * @param {!proto.mw.customer.CreateMiniShopOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mw.customer.CreateMiniShopOrderResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mw.customer.CreateMiniShopOrderResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mw.customer.CustomerServiceClient.prototype.createMiniShopOrder =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mw.customer.CustomerService/CreateMiniShopOrder',
      request,
      metadata || {},
      methodDescriptor_CustomerService_CreateMiniShopOrder,
      callback);
};


/**
 * @param {!proto.mw.customer.CreateMiniShopOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mw.customer.CreateMiniShopOrderResponse>}
 *     Promise that resolves to the response
 */
proto.mw.customer.CustomerServicePromiseClient.prototype.createMiniShopOrder =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mw.customer.CustomerService/CreateMiniShopOrder',
      request,
      metadata || {},
      methodDescriptor_CustomerService_CreateMiniShopOrder);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mw.customer.CaptureMiniShopOrderRequest,
 *   !proto.mw.customer.CaptureMiniShopOrderResponse>}
 */
const methodDescriptor_CustomerService_CaptureMiniShopOrder = new grpc.web.MethodDescriptor(
  '/mw.customer.CustomerService/CaptureMiniShopOrder',
  grpc.web.MethodType.UNARY,
  proto.mw.customer.CaptureMiniShopOrderRequest,
  proto.mw.customer.CaptureMiniShopOrderResponse,
  /**
   * @param {!proto.mw.customer.CaptureMiniShopOrderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mw.customer.CaptureMiniShopOrderResponse.deserializeBinary
);


/**
 * @param {!proto.mw.customer.CaptureMiniShopOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mw.customer.CaptureMiniShopOrderResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mw.customer.CaptureMiniShopOrderResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mw.customer.CustomerServiceClient.prototype.captureMiniShopOrder =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mw.customer.CustomerService/CaptureMiniShopOrder',
      request,
      metadata || {},
      methodDescriptor_CustomerService_CaptureMiniShopOrder,
      callback);
};


/**
 * @param {!proto.mw.customer.CaptureMiniShopOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mw.customer.CaptureMiniShopOrderResponse>}
 *     Promise that resolves to the response
 */
proto.mw.customer.CustomerServicePromiseClient.prototype.captureMiniShopOrder =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mw.customer.CustomerService/CaptureMiniShopOrder',
      request,
      metadata || {},
      methodDescriptor_CustomerService_CaptureMiniShopOrder);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mw.customer.ValidateAddressRequest,
 *   !proto.mw.customer.ValidateAddressResponse>}
 */
const methodDescriptor_CustomerService_ValidateAddress = new grpc.web.MethodDescriptor(
  '/mw.customer.CustomerService/ValidateAddress',
  grpc.web.MethodType.UNARY,
  proto.mw.customer.ValidateAddressRequest,
  proto.mw.customer.ValidateAddressResponse,
  /**
   * @param {!proto.mw.customer.ValidateAddressRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mw.customer.ValidateAddressResponse.deserializeBinary
);


/**
 * @param {!proto.mw.customer.ValidateAddressRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mw.customer.ValidateAddressResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mw.customer.ValidateAddressResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mw.customer.CustomerServiceClient.prototype.validateAddress =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mw.customer.CustomerService/ValidateAddress',
      request,
      metadata || {},
      methodDescriptor_CustomerService_ValidateAddress,
      callback);
};


/**
 * @param {!proto.mw.customer.ValidateAddressRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mw.customer.ValidateAddressResponse>}
 *     Promise that resolves to the response
 */
proto.mw.customer.CustomerServicePromiseClient.prototype.validateAddress =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mw.customer.CustomerService/ValidateAddress',
      request,
      metadata || {},
      methodDescriptor_CustomerService_ValidateAddress);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mw.customer.TrackUsageRequest,
 *   !proto.mw.customer.TrackUsageResponse>}
 */
const methodDescriptor_CustomerService_TrackUsage = new grpc.web.MethodDescriptor(
  '/mw.customer.CustomerService/TrackUsage',
  grpc.web.MethodType.UNARY,
  proto.mw.customer.TrackUsageRequest,
  proto.mw.customer.TrackUsageResponse,
  /**
   * @param {!proto.mw.customer.TrackUsageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mw.customer.TrackUsageResponse.deserializeBinary
);


/**
 * @param {!proto.mw.customer.TrackUsageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mw.customer.TrackUsageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mw.customer.TrackUsageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mw.customer.CustomerServiceClient.prototype.trackUsage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mw.customer.CustomerService/TrackUsage',
      request,
      metadata || {},
      methodDescriptor_CustomerService_TrackUsage,
      callback);
};


/**
 * @param {!proto.mw.customer.TrackUsageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mw.customer.TrackUsageResponse>}
 *     Promise that resolves to the response
 */
proto.mw.customer.CustomerServicePromiseClient.prototype.trackUsage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mw.customer.CustomerService/TrackUsage',
      request,
      metadata || {},
      methodDescriptor_CustomerService_TrackUsage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mw.customer.ErrorRequest,
 *   !proto.mw.customer.ErrorResponse>}
 */
const methodDescriptor_CustomerService_Error = new grpc.web.MethodDescriptor(
  '/mw.customer.CustomerService/Error',
  grpc.web.MethodType.UNARY,
  proto.mw.customer.ErrorRequest,
  proto.mw.customer.ErrorResponse,
  /**
   * @param {!proto.mw.customer.ErrorRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mw.customer.ErrorResponse.deserializeBinary
);


/**
 * @param {!proto.mw.customer.ErrorRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mw.customer.ErrorResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mw.customer.ErrorResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mw.customer.CustomerServiceClient.prototype.error =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mw.customer.CustomerService/Error',
      request,
      metadata || {},
      methodDescriptor_CustomerService_Error,
      callback);
};


/**
 * @param {!proto.mw.customer.ErrorRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mw.customer.ErrorResponse>}
 *     Promise that resolves to the response
 */
proto.mw.customer.CustomerServicePromiseClient.prototype.error =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mw.customer.CustomerService/Error',
      request,
      metadata || {},
      methodDescriptor_CustomerService_Error);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mw.customer.GetSkinAnalysisFormRequest,
 *   !proto.mw.customer.GetSkinAnalysisFormResponse>}
 */
const methodDescriptor_CustomerService_GetSkinAnalysisForm = new grpc.web.MethodDescriptor(
  '/mw.customer.CustomerService/GetSkinAnalysisForm',
  grpc.web.MethodType.UNARY,
  proto.mw.customer.GetSkinAnalysisFormRequest,
  proto.mw.customer.GetSkinAnalysisFormResponse,
  /**
   * @param {!proto.mw.customer.GetSkinAnalysisFormRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mw.customer.GetSkinAnalysisFormResponse.deserializeBinary
);


/**
 * @param {!proto.mw.customer.GetSkinAnalysisFormRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mw.customer.GetSkinAnalysisFormResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mw.customer.GetSkinAnalysisFormResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mw.customer.CustomerServiceClient.prototype.getSkinAnalysisForm =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mw.customer.CustomerService/GetSkinAnalysisForm',
      request,
      metadata || {},
      methodDescriptor_CustomerService_GetSkinAnalysisForm,
      callback);
};


/**
 * @param {!proto.mw.customer.GetSkinAnalysisFormRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mw.customer.GetSkinAnalysisFormResponse>}
 *     Promise that resolves to the response
 */
proto.mw.customer.CustomerServicePromiseClient.prototype.getSkinAnalysisForm =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mw.customer.CustomerService/GetSkinAnalysisForm',
      request,
      metadata || {},
      methodDescriptor_CustomerService_GetSkinAnalysisForm);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mw.customer.AnalyzeSkinProblemsRequest,
 *   !proto.mw.customer.AnalyzeSkinProblemsResponse>}
 */
const methodDescriptor_CustomerService_AnalyzeSkinProblems = new grpc.web.MethodDescriptor(
  '/mw.customer.CustomerService/AnalyzeSkinProblems',
  grpc.web.MethodType.UNARY,
  proto.mw.customer.AnalyzeSkinProblemsRequest,
  proto.mw.customer.AnalyzeSkinProblemsResponse,
  /**
   * @param {!proto.mw.customer.AnalyzeSkinProblemsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mw.customer.AnalyzeSkinProblemsResponse.deserializeBinary
);


/**
 * @param {!proto.mw.customer.AnalyzeSkinProblemsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mw.customer.AnalyzeSkinProblemsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mw.customer.AnalyzeSkinProblemsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mw.customer.CustomerServiceClient.prototype.analyzeSkinProblems =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mw.customer.CustomerService/AnalyzeSkinProblems',
      request,
      metadata || {},
      methodDescriptor_CustomerService_AnalyzeSkinProblems,
      callback);
};


/**
 * @param {!proto.mw.customer.AnalyzeSkinProblemsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mw.customer.AnalyzeSkinProblemsResponse>}
 *     Promise that resolves to the response
 */
proto.mw.customer.CustomerServicePromiseClient.prototype.analyzeSkinProblems =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mw.customer.CustomerService/AnalyzeSkinProblems',
      request,
      metadata || {},
      methodDescriptor_CustomerService_AnalyzeSkinProblems);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mw.customer.GetProductRecommendationsRequest,
 *   !proto.mw.customer.GetProductRecommendationsResponse>}
 */
const methodDescriptor_CustomerService_GetProductRecommendations = new grpc.web.MethodDescriptor(
  '/mw.customer.CustomerService/GetProductRecommendations',
  grpc.web.MethodType.UNARY,
  proto.mw.customer.GetProductRecommendationsRequest,
  proto.mw.customer.GetProductRecommendationsResponse,
  /**
   * @param {!proto.mw.customer.GetProductRecommendationsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mw.customer.GetProductRecommendationsResponse.deserializeBinary
);


/**
 * @param {!proto.mw.customer.GetProductRecommendationsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mw.customer.GetProductRecommendationsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mw.customer.GetProductRecommendationsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mw.customer.CustomerServiceClient.prototype.getProductRecommendations =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mw.customer.CustomerService/GetProductRecommendations',
      request,
      metadata || {},
      methodDescriptor_CustomerService_GetProductRecommendations,
      callback);
};


/**
 * @param {!proto.mw.customer.GetProductRecommendationsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mw.customer.GetProductRecommendationsResponse>}
 *     Promise that resolves to the response
 */
proto.mw.customer.CustomerServicePromiseClient.prototype.getProductRecommendations =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mw.customer.CustomerService/GetProductRecommendations',
      request,
      metadata || {},
      methodDescriptor_CustomerService_GetProductRecommendations);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mw.customer.GetSkinProblemsForAnalysisRequest,
 *   !proto.mw.customer.GetSkinProblemsForAnalysisResponse>}
 */
const methodDescriptor_CustomerService_GetSkinProblemsForAnalysis = new grpc.web.MethodDescriptor(
  '/mw.customer.CustomerService/GetSkinProblemsForAnalysis',
  grpc.web.MethodType.UNARY,
  proto.mw.customer.GetSkinProblemsForAnalysisRequest,
  proto.mw.customer.GetSkinProblemsForAnalysisResponse,
  /**
   * @param {!proto.mw.customer.GetSkinProblemsForAnalysisRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mw.customer.GetSkinProblemsForAnalysisResponse.deserializeBinary
);


/**
 * @param {!proto.mw.customer.GetSkinProblemsForAnalysisRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mw.customer.GetSkinProblemsForAnalysisResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mw.customer.GetSkinProblemsForAnalysisResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mw.customer.CustomerServiceClient.prototype.getSkinProblemsForAnalysis =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mw.customer.CustomerService/GetSkinProblemsForAnalysis',
      request,
      metadata || {},
      methodDescriptor_CustomerService_GetSkinProblemsForAnalysis,
      callback);
};


/**
 * @param {!proto.mw.customer.GetSkinProblemsForAnalysisRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mw.customer.GetSkinProblemsForAnalysisResponse>}
 *     Promise that resolves to the response
 */
proto.mw.customer.CustomerServicePromiseClient.prototype.getSkinProblemsForAnalysis =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mw.customer.CustomerService/GetSkinProblemsForAnalysis',
      request,
      metadata || {},
      methodDescriptor_CustomerService_GetSkinProblemsForAnalysis);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mw.customer.AnalyzeSkinImagesRequest,
 *   !proto.mw.customer.AnalyzeSkinImagesResponse>}
 */
const methodDescriptor_CustomerService_AnalyzeSkinImages = new grpc.web.MethodDescriptor(
  '/mw.customer.CustomerService/AnalyzeSkinImages',
  grpc.web.MethodType.UNARY,
  proto.mw.customer.AnalyzeSkinImagesRequest,
  proto.mw.customer.AnalyzeSkinImagesResponse,
  /**
   * @param {!proto.mw.customer.AnalyzeSkinImagesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mw.customer.AnalyzeSkinImagesResponse.deserializeBinary
);


/**
 * @param {!proto.mw.customer.AnalyzeSkinImagesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mw.customer.AnalyzeSkinImagesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mw.customer.AnalyzeSkinImagesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mw.customer.CustomerServiceClient.prototype.analyzeSkinImages =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mw.customer.CustomerService/AnalyzeSkinImages',
      request,
      metadata || {},
      methodDescriptor_CustomerService_AnalyzeSkinImages,
      callback);
};


/**
 * @param {!proto.mw.customer.AnalyzeSkinImagesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mw.customer.AnalyzeSkinImagesResponse>}
 *     Promise that resolves to the response
 */
proto.mw.customer.CustomerServicePromiseClient.prototype.analyzeSkinImages =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mw.customer.CustomerService/AnalyzeSkinImages',
      request,
      metadata || {},
      methodDescriptor_CustomerService_AnalyzeSkinImages);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mw.customer.GetSuggestedProductsRequest,
 *   !proto.mw.customer.GetSuggestedProductsResponse>}
 */
const methodDescriptor_CustomerService_GetSuggestedProducts = new grpc.web.MethodDescriptor(
  '/mw.customer.CustomerService/GetSuggestedProducts',
  grpc.web.MethodType.UNARY,
  proto.mw.customer.GetSuggestedProductsRequest,
  proto.mw.customer.GetSuggestedProductsResponse,
  /**
   * @param {!proto.mw.customer.GetSuggestedProductsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mw.customer.GetSuggestedProductsResponse.deserializeBinary
);


/**
 * @param {!proto.mw.customer.GetSuggestedProductsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mw.customer.GetSuggestedProductsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mw.customer.GetSuggestedProductsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mw.customer.CustomerServiceClient.prototype.getSuggestedProducts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mw.customer.CustomerService/GetSuggestedProducts',
      request,
      metadata || {},
      methodDescriptor_CustomerService_GetSuggestedProducts,
      callback);
};


/**
 * @param {!proto.mw.customer.GetSuggestedProductsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mw.customer.GetSuggestedProductsResponse>}
 *     Promise that resolves to the response
 */
proto.mw.customer.CustomerServicePromiseClient.prototype.getSuggestedProducts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mw.customer.CustomerService/GetSuggestedProducts',
      request,
      metadata || {},
      methodDescriptor_CustomerService_GetSuggestedProducts);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mw.customer.RegisterStudentRequest,
 *   !proto.mw.customer.RegisterStudentResponse>}
 */
const methodDescriptor_CustomerService_RegisterStudent = new grpc.web.MethodDescriptor(
  '/mw.customer.CustomerService/RegisterStudent',
  grpc.web.MethodType.UNARY,
  proto.mw.customer.RegisterStudentRequest,
  proto.mw.customer.RegisterStudentResponse,
  /**
   * @param {!proto.mw.customer.RegisterStudentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mw.customer.RegisterStudentResponse.deserializeBinary
);


/**
 * @param {!proto.mw.customer.RegisterStudentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mw.customer.RegisterStudentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mw.customer.RegisterStudentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mw.customer.CustomerServiceClient.prototype.registerStudent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mw.customer.CustomerService/RegisterStudent',
      request,
      metadata || {},
      methodDescriptor_CustomerService_RegisterStudent,
      callback);
};


/**
 * @param {!proto.mw.customer.RegisterStudentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mw.customer.RegisterStudentResponse>}
 *     Promise that resolves to the response
 */
proto.mw.customer.CustomerServicePromiseClient.prototype.registerStudent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mw.customer.CustomerService/RegisterStudent',
      request,
      metadata || {},
      methodDescriptor_CustomerService_RegisterStudent);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mw.customer.VerifyStudentEmailRequest,
 *   !proto.mw.customer.VerifyStudentEmailResponse>}
 */
const methodDescriptor_CustomerService_VerifyStudentEmail = new grpc.web.MethodDescriptor(
  '/mw.customer.CustomerService/VerifyStudentEmail',
  grpc.web.MethodType.UNARY,
  proto.mw.customer.VerifyStudentEmailRequest,
  proto.mw.customer.VerifyStudentEmailResponse,
  /**
   * @param {!proto.mw.customer.VerifyStudentEmailRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mw.customer.VerifyStudentEmailResponse.deserializeBinary
);


/**
 * @param {!proto.mw.customer.VerifyStudentEmailRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mw.customer.VerifyStudentEmailResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mw.customer.VerifyStudentEmailResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mw.customer.CustomerServiceClient.prototype.verifyStudentEmail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mw.customer.CustomerService/VerifyStudentEmail',
      request,
      metadata || {},
      methodDescriptor_CustomerService_VerifyStudentEmail,
      callback);
};


/**
 * @param {!proto.mw.customer.VerifyStudentEmailRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mw.customer.VerifyStudentEmailResponse>}
 *     Promise that resolves to the response
 */
proto.mw.customer.CustomerServicePromiseClient.prototype.verifyStudentEmail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mw.customer.CustomerService/VerifyStudentEmail',
      request,
      metadata || {},
      methodDescriptor_CustomerService_VerifyStudentEmail);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mw.customer.UploadStudentDocumentsRequest,
 *   !proto.mw.customer.UploadStudentDocumentsResponse>}
 */
const methodDescriptor_CustomerService_UploadStudentDocuments = new grpc.web.MethodDescriptor(
  '/mw.customer.CustomerService/UploadStudentDocuments',
  grpc.web.MethodType.UNARY,
  proto.mw.customer.UploadStudentDocumentsRequest,
  proto.mw.customer.UploadStudentDocumentsResponse,
  /**
   * @param {!proto.mw.customer.UploadStudentDocumentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mw.customer.UploadStudentDocumentsResponse.deserializeBinary
);


/**
 * @param {!proto.mw.customer.UploadStudentDocumentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mw.customer.UploadStudentDocumentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mw.customer.UploadStudentDocumentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mw.customer.CustomerServiceClient.prototype.uploadStudentDocuments =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mw.customer.CustomerService/UploadStudentDocuments',
      request,
      metadata || {},
      methodDescriptor_CustomerService_UploadStudentDocuments,
      callback);
};


/**
 * @param {!proto.mw.customer.UploadStudentDocumentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mw.customer.UploadStudentDocumentsResponse>}
 *     Promise that resolves to the response
 */
proto.mw.customer.CustomerServicePromiseClient.prototype.uploadStudentDocuments =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mw.customer.CustomerService/UploadStudentDocuments',
      request,
      metadata || {},
      methodDescriptor_CustomerService_UploadStudentDocuments);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mw.customer.GetStudentStatusRequest,
 *   !proto.mw.customer.GetStudentStatusResponse>}
 */
const methodDescriptor_CustomerService_GetStudentStatus = new grpc.web.MethodDescriptor(
  '/mw.customer.CustomerService/GetStudentStatus',
  grpc.web.MethodType.UNARY,
  proto.mw.customer.GetStudentStatusRequest,
  proto.mw.customer.GetStudentStatusResponse,
  /**
   * @param {!proto.mw.customer.GetStudentStatusRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mw.customer.GetStudentStatusResponse.deserializeBinary
);


/**
 * @param {!proto.mw.customer.GetStudentStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mw.customer.GetStudentStatusResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mw.customer.GetStudentStatusResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mw.customer.CustomerServiceClient.prototype.getStudentStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mw.customer.CustomerService/GetStudentStatus',
      request,
      metadata || {},
      methodDescriptor_CustomerService_GetStudentStatus,
      callback);
};


/**
 * @param {!proto.mw.customer.GetStudentStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mw.customer.GetStudentStatusResponse>}
 *     Promise that resolves to the response
 */
proto.mw.customer.CustomerServicePromiseClient.prototype.getStudentStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mw.customer.CustomerService/GetStudentStatus',
      request,
      metadata || {},
      methodDescriptor_CustomerService_GetStudentStatus);
};


module.exports = proto.mw.customer;

